import { useContext } from 'react';
import { StoreContexto } from '../Contexto/Provider';
import Init from '../Funções/Init';

export function apiService() {
  const { auth } = useContext(StoreContexto);

  const errorHandler = (error) => {
    // TODO: Implement a more robust error handling mechanism
    console.error('API Error:', error);
    throw error;
  };

  const fetchApi = async ({ method, subroute = '', body = {}, queryParams = {} }) => {
    const queryString = new URLSearchParams(queryParams).toString();
    const url = `${Init.url}${subroute}${queryString ? `?${queryString}` : ''}`;

    try {
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
        body: ['POST', 'PUT', 'DELETE'].includes(method) ? JSON.stringify(body) : null,
      });

      if (response.status === 204) {
        // No Content response
        return null;
      }

      const contentType = response.headers.get('Content-Type');
      if (contentType && contentType.includes('application/json')) {
        const data = await response.json();
        if (!response.ok) {
          throw data;
        }
        return data;
      } else if (!response.ok) {
        const errorData = await response.text();
        throw new Error(errorData || 'API request failed');
      }

      return {};
    } catch (error) {
      errorHandler(error);
    }
  };

  const fetchFile = async ({ subroute = '', queryParams = {} }) => {
    const queryString = new URLSearchParams(queryParams).toString();
    const url = `${Init.url}${subroute}${queryString ? `?${queryString}` : ''}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.text();
        throw new Error(errorData || 'API request failed');
      }

      const blob = await response.blob();
      return blob;
    } catch (error) {
      errorHandler(error);
    }
  };

  const get = (subroute, queryParams) => fetchApi({ method: 'GET', subroute, queryParams });
  const post = (subroute, body) => fetchApi({ method: 'POST', subroute, body });
  const put = (subroute, body) => fetchApi({ method: 'PUT', subroute, body });
  const del = (subroute, body) => fetchApi({ method: 'DELETE', subroute, body });
  const getFile = (subroute, queryParams) => fetchFile({ subroute, queryParams });

  return { get, post, put, del, getFile };
}
